import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var o;
!function (o) {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(i);

  var t = function t(o, _t2, n, e) {
    var i = _t2,
        c = _t2;
    var l = n >>> 1,
        r = o[i - 1];

    for (; c <= l;) {
      c = i << 1, c < n && e(o[c - 1], o[c]) < 0 && ++c;
      var _t = o[c - 1];
      if (e(_t, r) <= 0) break;
      o[i - 1] = _t, i = c;
    }

    o[i - 1] = r;
  },
      n = function n(o, t) {
    return o < t ? -1 : o > t ? 1 : 0;
  };

  function e(o, e, i, c) {
    void 0 === e && (e = 0), void 0 === i && (i = o.length), void 0 === c && (c = n);

    for (var _n = i >>> 1; _n > e; _n--) {
      t(o, _n, i, c);
    }

    var l = e + 1;

    for (var _n2 = i - 1; _n2 > e; _n2--) {
      var _i = o[e];
      o[e] = o[_n2], o[_n2] = _i, t(o, l, _n2, c);
    }
  }

  function i(o, e, i, c) {
    var _n3, l, _n4, _i2;

    return _regeneratorRuntime.wrap(function i$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            void 0 === e && (e = 0), void 0 === i && (i = o.length), void 0 === c && (c = n);
            _n3 = i >>> 1;

          case 2:
            if (!(_n3 > e)) {
              _context.next = 9;
              break;
            }

            t(o, _n3, i, c);
            _context.next = 6;
            return;

          case 6:
            _n3--;
            _context.next = 2;
            break;

          case 9:
            l = e + 1;
            _n4 = i - 1;

          case 11:
            if (!(_n4 > e)) {
              _context.next = 21;
              break;
            }

            _i2 = o[e];
            o[e] = o[_n4];
            o[_n4] = _i2;
            t(o, l, _n4, c);
            _context.next = 18;
            return;

          case 18:
            _n4--;
            _context.next = 11;
            break;

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _marked);
  }

  o.sort = e, o.iterableSort = i;
}(o || (o = {}));
var t = o;
export { t as default };